import { ComponentUtil } from '../../utils/ComponentUtil';
import { Hooks } from '../../types/Hooks';

ComponentUtil.loader(
  !!document.querySelector(Hooks.CollectionSectionRoot),
  () => import('./CollectionSection'),
  (CollectionSection) => {
    ComponentUtil.binder(Hooks.CollectionSectionRoot, CollectionSection);
  },
);
